import React from 'react';
import Container from 'container';
import Miscellaneous from 'shared/hero-miscellaneous';
import Headline from 'headline';
import { useHeroImage } from '../../../hooks/useHeroImage';
import s from './hero.module.scss';

export default function Hero({
  title,
  image,
  blueOverlay,
  fullheight,
  mobile_image,
  ...props
}) {
  const { heroImage } = useHeroImage({ image, mobile_image });


  const fullheightClass = fullheight ? s.fullheight : '';
  return (
    <Container
      className={`${s.root} ${fullheightClass}`}
      image={heroImage}
      blueOverlay
    >
      <div className={s.wrapper}>
        <Headline underlined={blueOverlay} h1 center white category={title}>
          {title && title.replace(/&Amp;/gim, '&')}
        </Headline>
        <Miscellaneous />
      </div>
    </Container>
  );
}
